import * as yup from "yup";

export type MakePrimaryFormValues = {
    justification: string;
};

export const makePrimaryFormValidationSchema = yup.object({
    justification: yup.string().required("Please enter a justification"),
});
